module.exports = __webpack_public_path__ + "img/p2_preview_b3.e564cb21.jpg";